import { trans } from '@spotahome/soyuz/client';

const getFaqKeys = () => [
  {
    top: 'listing.faqs.item-1.title',
    content: 'listing.faqs.item-1.content'
  },
  {
    top: 'listing.faqs.item-2.title',
    content: 'listing.faqs.item-2.content'
  },
  {
    top: 'listing.faqs.item-3.title',
    content: 'listing.faqs.item-3.content'
  },
  {
    top: 'listing.faqs.item-4.title',
    content: 'listing.faqs.item-4.content'
  },
  {
    top: 'listing.faqs.item-5.title',
    content: 'listing.faqs.item-5.content'
  },
  {
    top: 'listing.faqs.item-6.title',
    content: 'listing.faqs.item-6.content'
  }
];

export const getFaqs = () =>
  getFaqKeys().map(faq => ({
    top: trans(faq.top),
    content: trans(faq.content)
  }));

export default { getFaqs };
